export default "__VITE_ASSET__BULPHs25__"